import React, { Component } from 'react';
import './program.css';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import * as programActions from './programAction';
//import { layer } from '@fortawesome/fontawesome-svg-core';
import ModalForm from '../Modal/modal';
//import TDIObject from '../TDIObject/tdiobject';

//import { Switch } from 'react-router-dom';


class Program extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
        this.state = {
            modalShow:false,
            modalType:"CONTRACT",
            modalName:"Add Contract",
            modalReset:false,
            formData:null,
            ids:{},
            insureds:[],
        };

    }

    updateFormData = (data) =>{
        console.log(data);
        this.setState({formData:data});
    }

    onHandleModalClose = (data) =>{
        console.log("DATA FORM:",data);
        if(data !==null){
            var newInsuredList = [...this.state.insureds];
            switch (data.type) {
                case "CONTRACT":
                    newInsuredList.push(
                        {
                            insuredName:data.name, 
                            risks:[
                            ],
                        }
                    );
                    break;
                case "RISK":
                    newInsuredList[data.contractId].risks.push(
                        {
                            name:data.name,
                            riskType:data.riskType,
                            schedules:[
                                {percent:100}
                            ],
                            layers:[
                            ],
                            types:[
                            ]
                            
                        }
                    );
                    break;
                default:
                    break;
            }
            
            this.setState({insureds:newInsuredList,modalShow:false,formData:null});


        }else{
            this.setState({modalShow:false}); 
        }
        
    }


    addContract  = () =>{
        this.setState({modalShow:true,modalType:"CONTRACT",modalName:"Add Contract"});
    }

    addRisk  = (i) =>{
        this.setState({modalShow:true,modalType:"RISK",modalName:"Add Risk",ids:{i:i}});
        
    }

    addSchedule  = (i,j) =>{
        var newInsuredList = [...this.state.insureds];
        newInsuredList[i].risks[j].schedules.push(
            {percent:100}
        )

        this.setState({modalShow:true,modalType:"SCHEDULE",modalName:"Add Schedule",ids:{i:i,j:j}});    
        //this.setState({insureds:newInsuredList});
    }

    addLayer  = (i,j) =>{
        var newInsuredList = [...this.state.insureds];
        if(newInsuredList[i].risks[j].layers.length === 0){
            newInsuredList[i].risks[j].layers.push(
                {
                    boundary:100,
                },
            )
        }else{
            newInsuredList[i].risks[j].layers.push(
                {
                    boundary:newInsuredList[i].risks[j].layers[newInsuredList[i].risks[j].layers.length-1].boundary+100,
                },
            )
        }
        


        this.setState({insureds:newInsuredList});
    }

    changeType  = (i,j,k,l) =>{
        var newInsuredList = [...this.state.insureds];
        if(newInsuredList[i].risks[j].types.filter(type=>type.schedule ===k && type.layer===l).length === 0){
            newInsuredList[i].risks[j].types.push(
                {
                    schedule:k,
                    layer:l,
                    type:"empty",
                    name:"Franchise"
                }
            )
        }else{
            newInsuredList[i].risks[j].types.forEach(type => {
                if(type.schedule ===k && type.layer===l){
                    switch( type.type){
                        case "empty":
                            type.type = "assureur";
                            type.name = "Assureur 1";
                            break;
                        case "assureur":
                            type.type = "reassureur";
                            type.name = "Reassureur 1";
                            break; 
                        case "reassureur":
                            type.type = "tbd";
                            type.name = "";
                            break;
                        case "tbd":
                            type.type = "empty";
                            type.name = "Franchise";
                            break; 
                        default :
                            break; 
                    }
                }
            });

            
        }
        


        this.setState({insureds:newInsuredList});
    }

    createContract = () =>{
        
        var insureds = this.state.insureds.map((insured,i) =>
        {
            var risks = insured.risks.map((risk,j) =>{
                var schedules = risk.schedules.map((schedule,k)=>{
                    var previousBoundary = 0;
                    var layers = risk.layers.map((layer,l)=>{
                        var ponderate = (layer.boundary - previousBoundary);
                        previousBoundary = layer.boundary;
                        var type = risk.types.filter(type=>type.schedule ===k && type.layer===l);
                        
                        return (
                            <div key={l} className={type.length>0?"layer-container ponderate"+ponderate+" "+type[0].type:"layer-container ponderate"+ponderate+" tbd"} onClick={this.changeType.bind(this,i,j,k,l)} title={type.length>0?type[0].name:"To Be Defined"}>
                                <div className="layer-end">{layer.boundary}k</div>
                                <div>{type.length>0?type[0].name:"TBD"}</div>
                            </div>
                        )
                    });
                    
                    return (
                        <div key={k} className={"schedule-container ponderate"+schedule.percent}>
                            <div className="schedule-percent">{schedule.percent}%</div>
                            <div className="schedule-body">
                                {layers}
                            </div>
                            
                        </div>
                    )
                });
                


                return (
                    <div key={j} className="risk-container">
                        <div className="risk-name"><div>{risk.name} ({risk.riskType}) </div><div className="quickAction" onClick={this.addSchedule.bind(this,i,j)}>+ Schedule</div></div>
                        <div className="risk-body">
                            {schedules}
                        </div>
                        <div className="quickAction" onClick={this.addLayer.bind(this,i,j)}>+ Layer</div>
                    </div>
                )
            });
            return(
                <div key={i} className={insured.risks.length>0?"insured-container ponderate"+insured.risks.length+"00":"insured-container ponderate100"}>
                    <div className="insured-name"><div>{insured.insuredName}</div><div className="quickAction" onClick={this.addRisk.bind(this,i)}>+ Risk</div></div>
                    <div className="insured-body">
                        {risks}
                    </div>
                </div>
            )
   
        }
        );


        return (
            <div className="program-body">
                {insureds}
            </div>
            
        );
    }
  
    render() {
        var insureds = this.createContract();
        return (
            <div className="program-wrapper" >
                <div>Header </div>
                
                <div className="program-outerwrapper">
                    <div className="program-item">
                        <div className="program-name"><div>Program Name</div><div className="quickAction" onClick={this.addContract.bind()}>+ Contract</div></div>
                        <div className="program-body">
                            {insureds}
                        </div>
                    </div>

                </div>
                <ModalForm 
                    onUpdateFormData={this.updateFormData.bind()} 
                    data={this.state.formData} 
                    show={this.state.modalShow} 
                    ids={this.state.ids} 
                    type={this.state.modalType} 
                    name={this.state.modalName} 
                    onHandleClose={this.onHandleModalClose.bind()}
                >
                </ModalForm>
            </div>
        );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Program);
  